
export default {
  name: 'BbTooltip',
  props: {
    alignment: {
      type: String,
      default: 'top',
    },
    content: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '267px',
    },
    offset: {
      type: String,
      default: '4',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedProps() {
      return {
        placement: this.alignment,
        offset: this.offset,
        popoverBaseClass: 'bb-tooltip',
        popoverClass: '',
        trigger: 'hover',
        disabled: this.isDisabled,
      };
    },
    computedPopoverStyle() {
      return {
        'max-width': this.width,
      };
    },
  },
};
